module.exports = __webpack_public_path__ + "img/img-carousel3.26ede26e.jpg";